import { createSlice } from "@reduxjs/toolkit"

import { AccountCreationStatus } from "#/shared/types"

export type AccountState = {
  authId: string | null
  username: string
  accountCreationStatus: AccountCreationStatus
  hasModifiedUsername: boolean
  loadingAccountData: boolean
}

const initialState: AccountState = {
  authId: null,
  username: "",
  accountCreationStatus: AccountCreationStatus.Idle,
  hasModifiedUsername: false,
  loadingAccountData: false,
}

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setUsername: (immerState, { payload }: { payload: string }) => {
      immerState.username = payload
    },
    setUserAuthId: (immerState, { payload }: { payload: string | null }) => {
      immerState.authId = payload
    },
    setHasModifiedUsername: (immerState, { payload }: { payload: boolean }) => {
      immerState.hasModifiedUsername = payload
    },
    setAccountCreationStatus: (
      immerState,
      { payload }: { payload: AccountCreationStatus },
    ) => {
      immerState.accountCreationStatus = payload
    },
    setLoadingAccountData: (immerState, { payload }: { payload: boolean }) => {
      immerState.loadingAccountData = payload
    },
    resetAccount: () => initialState,
  },
})

export const {
  setUsername,
  setUserAuthId,
  setHasModifiedUsername,
  setAccountCreationStatus,
  setLoadingAccountData,
  resetAccount,
} = accountSlice.actions

export default accountSlice.reducer
